import prodClient from 'client/prod';
import messages from 'messages/de.ton.json';

prodClient(messages);
